import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    monoDigit: {
        display: "inline-block !important",
        width: "0.6em !important",
        textAlign: "center !important",
    },
});

const PhoneNumber = ({ number }) => {
    const classes = useStyles();

    const wrappedNumber = [...number].map((char, i) => {
        if (/\d/.test(char)) {
            return (
                <span key={i} className={classes.monoDigit}>
          {char}
        </span>
            );
        }
        return char;
    });

    return <span>{wrappedNumber}</span>;
};

export default PhoneNumber;
